module.exports = __webpack_public_path__ + "img/yishi18.47567009.jpg";